<template>
  <el-collapse v-model="activeName1" class="p-collapse" v-if="infoList.length">
    <el-collapse-item name="1" class="collapse-item-1">
      <div slot="title" class="c-tt-1">
        常见问题解答
      </div>
      <div>
        <el-collapse v-model="activeName2">
          <el-collapse-item v-for="(o, i) in infoList" :key="i" :name="`${i + 1}`">
            <div slot="title" class="c-tt-2 t-overflow">
              {{o.problemName}}
            </div>
            <div>
              <template v-if="o.problemAnswer">
                <p v-for="(item, j) in o.problemAnswer.split('\n')" :key="j">{{item}}</p>
              </template>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'commonProblem',
  props: {
    infoList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      activeName1: '1',
      activeName2: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
